export const LANDING_PAGE_URL = "/";
export const IMAGES_PAGE_URL = "/album";
